import { Box, Card, Footer, PageLayout } from '@bharatpe/bharat-ui';
import React, { useEffect } from 'react';
import LeftIcon from 'assets/images/autoPay/congratulations.png';
import { useUserUpiBankList } from 'Slices';
import AllModals from '../Modals';
import history from 'utils/History';
import UpiPoweredBy from 'components/atoms/UpiPoweredBy';
import { customSubScribeBackButton } from 'utils/nativeSupport';
import { deviceBindingRedirectionHandle } from 'utils/deviceBindingHelper';
import { logAnalyticsEvent } from 'utils/AnalyticsEvent';
import { useLanguageConfig } from 'Slices/LanguageConfigSlice';

const UpiSucessfull = () => {
	const bankDetails = useUserUpiBankList();
	const { languageData } = useLanguageConfig();

	const handleNext = () => {
		logAnalyticsEvent({
			trigger_point: `Clicks Continue`,
			Product: 'AutoPayUPI',
			Flow: 'SetupUPI',
			Screen: 'LinkUPI',
			Module: 'Setup_Autopay',
			Element: 'CTA',
			Action: 'Tapped',
			ctaType: 'setupAutoPay',
		});
		deviceBindingRedirectionHandle();
	};

	useEffect(() => {
		logAnalyticsEvent({
			trigger_point: 'Congratulations Screen',
			Product: 'AutoPayUPI',
			Flow: 'SetupUPI',
			Screen: 'LinkUPI',
			Module: 'Page',
			Action: 'Viewed',
		});
	}, []);
	useEffect(() => {
		customSubScribeBackButton(() => {
			handleBack();
		});
	}, [history]);

	const handleBack = () => {
		deviceBindingRedirectionHandle(true);
	};

	return (
		<PageLayout
			className="pb18 white-background"
			footerContent={<Footer primaryActionText={languageData.SET_AUTOPAY} primaryAction={handleNext} />}>
			<>
				<div className="m4 mt16">
					<Card className="p4 content-center">
						<div className="flex flex-column mt4">
							<div className="content-center mt4 mb4">
								<img src={LeftIcon} width={92} height={120} />
							</div>

							<div className="content-center mt4 mb3">
								<p className="SemiBold600">{languageData.CONGRATULATIONS}</p>
							</div>
							<div className="content-center mt2">
								<p className="Regular200">
									{languageData.BANK_PROVIDER_NAME_BANK_ACCOUNT_ACCOUNT_NUMBER_HAS_BEEN.replace(
										'{0}',
										bankDetails?.bankData[0]?.bank_provider_name,
									).replace('{1}', bankDetails?.bankData[0].account.slice(-8))}
								</p>
							</div>
							<div className="content-center mt1">
								<p className="Regular200">{languageData.SUCCESSFULLY_ADDED_AND_LINKED_TO}</p>
							</div>
							<div className="content-center">
								<Box
									style={{
										background: '#F4F9FF',
										borderRadius: '5px 10px',
										padding: '3px 10px',
										marginTop: '10px',
									}}>
									<p className="Regular100">{bankDetails?.vpa}</p>
								</Box>
							</div>
						</div>
					</Card>
				</div>
				<div className="upi-powered-with-margin">
					<UpiPoweredBy />
				</div>
				<AllModals />
			</>
		</PageLayout>
	);
};

export default UpiSucessfull;
